import { Injectable } from '@angular/core';
import { AbstractRelatorioService } from '../abstract-relatorio.service';

@Injectable({
  providedIn: 'root'
})
export class RelatorioConsultaService extends AbstractRelatorioService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'consulta';
  }

}
